var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "import-modal-file-item" },
    [
      _c("div", { staticClass: "import-modal-file-item__filename" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.file.name) + "\n\t")
      ]),
      _vm._v(" "),
      _c("CalendarPicker", {
        staticClass: "import-modal-file-item__calendar-select",
        attrs: { calendar: _vm.calendar, calendars: _vm.calendars },
        on: { selectCalendar: _vm.selectCalendar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }